// This file is used only on production (on ng build)
import { RunningConfig } from "app/core/config/config.model";
import { commonRunningConfig } from "../app/core/config/config-common";
export const environment: RunningConfig = { ...commonRunningConfig, production: true };
